quoteModule.controller('vehicleSingleProductController',
['$scope', 'quoteCreationEvents','vehicleProductCoordService','SingleProductInfo', 'rateQuoteRetrievalCoordService',
    'rateQuoteCoordService','rateQuoteScenariosService','dealerPreferencesService', 'vehicleRateService', '$mdDialog', '$mdMedia',
    'TLCError','AppErrorCodes', 'quoteIntegrationConstants','dealProductService','erateSessionVarsService','growl',
function ($scope, quoteCreationEvents, vehicleProductCoordService,SingleProductInfo, rateQuoteRetrievalCoordService,
          rateQuoteCoordService, rateQuoteScenariosService, dealerPreferencesService, vehicleRateService, $mdDialog, $mdMedia,
          TLCError,AppErrorCodes, quoteIntegrationConstants, dealProductService, erateSessionVarsService, growl)
{
    /*
     This controller controls a single product, including coverage, deductibles, surcharges, and upgrades.
     Once the user selects enough to get the rate (usually coverage + deductible), we start the rating process.

     Anytime the user changes a choice, we load any subsequent options that are dependent, and potentially start
     rating again.
     */
    var self = this;
    $scope.providerUsesProductType = false;

    //initialize with directive element and the product we are covering
    self.init = function (element, productid, producttypeid) {
        $scope.providerUsesProductType = dealerPreferencesService.providerUsesProductType();

        self.$element = element;
        $scope.singleProductInfo.productInternalId = productid;
        $scope.singleProductInfo.productTypeInternalId = producttypeid;
        $scope.getDealerDisplayPreferences();//also initiates coverages
        $scope.checkProductComplete();
        $scope.checkDealInfoComplete();

    };
    //******
    // FYI - anytime we manually change a product option, the user has interrupted any "retrieval" process,
    //  so we force the .endQuoteRetrieval if it is going on this just ensures we save changes, etc.
    //******
    //scope data
    $scope.singleProductInfo = new SingleProductInfo();
    $scope.displaySettings = {};
    $scope.defaultSurcharges = [];
    $scope.productTypeChooseOK = true;

    $scope.getDealerDisplayPreferences = function(){
        dealerPreferencesService.getProductDisplayPreferences(
            $scope.providerUsesProductType ? $scope.singleProductInfo.productTypeInternalId : $scope.singleProductInfo.productInternalId, $scope.singleProductInfo.productTypeInternalId, rateQuoteCoordService.VehicleData.dateOfSale)//use date of sale
            .then(
                function setDisplayPreferences(responseData) {
                    $scope.displaySettings = responseData;
                    $scope.getCoverages();
                },
                function displayPreferencesErr(err) {
                    $scope.getCoverages();
                    throw new TLCError(new Error(err),AppErrorCodes.ProductController_DisplaySettingError);
                }
            );

        $scope.defaultSurcharges = [];

        $scope.getDefaultSurchargeOptions();

    }

    $scope.getDefaultSurchargeOptions = function(){
        dealerPreferencesService.getProviderDefaultSurcharges(
            $scope.providerUsesProductType ? $scope.singleProductInfo.productTypeInternalId : $scope.singleProductInfo.productInternalId, rateQuoteCoordService.VehicleData.dateOfSale)
            .then(
                function setSurcharges(responseSurcharges) {
                    if (responseSurcharges && responseSurcharges.length > 0) {
                        $scope.defaultSurcharges = responseSurcharges.filter(function (surcharge) {
                            return surcharge.UserChoseSurcharge;
                        });
                    }
                    $scope.singleProductInfo.surchargeDefaultsRetrieved = true;
                    $scope.getProductOptionsSurcharges();
                },
                function displayPreferencesErr(err) {
                    //just continue processing.. no surcharge defaults
                    //throw new TLCError(new Error(err),AppErrorCodes.ProductController_DisplaySettingError);
                    $scope.singleProductInfo.surchargeDefaultsRetrieved = true;
                    $scope.getProductOptionsSurcharges();
                }
            );
    }


    $scope.initSelectedValues = function(){
        //clear out "selected values"
        $scope.singleProductInfo.selectedCoverageVal =
            $scope.singleProductInfo.selectedDeductibleVal =
                $scope.singleProductInfo.selectedNoUpgradeTermVal =
                    $scope.singleProductInfo.selectedUpgradeCoverageVal =
                        $scope.singleProductInfo.selectedUpgradeDeductibleVal = null;
        $scope.singleProductInfo.selectedUpgradeOptionVal = [];
        $scope.singleProductInfo.selectedOptionVal = [];
        //Adding a selectedOptionValDisplay to have a variable to use as a model to display the Option/Surcharges chosen on the UI; it will not be used for anything else.
        $scope.singleProductInfo.selectedOptionValDisplay = [];
        //Adding a selectedUpgradeOptionValDisplay to have a variable to use as a model to display the upgrade Option/Surcharges chosen on the UI; it will not be used for anything else.
        $scope.singleProductInfo.selectedUpgradeOptionValDisplay = [];
        $scope.singleproductShowRerate = false;
    }
    //toggle if option is chosen or not
    $scope.toggleOption = function(optionId, showRerate){
        rateQuoteRetrievalCoordService.endQuoteRetrieval();
        var idx = $scope.singleProductInfo.selectedOptionVal.indexOf(optionId);
        var defaultDeductibleSurcharge = _.find($scope.singleProductInfo.availOptions, function (nxtSurcharge) { return nxtSurcharge.ApplicationCode.indexOf(optionId) >= 0;});
        var defaultDeductibleValue =  _.find(defaultDeductibleSurcharge.PartnerSpecificFields.FlexFields, function (defaultDeductibleFlexField) { return defaultDeductibleFlexField.FieldName.indexOf("DefaultDeductible") >= 0;});
        if (idx > -1){
            $scope.singleProductInfo.selectedOptionVal.splice(idx,1);
            if (defaultDeductibleValue)
                $scope.singleProductInfo.defaultDeductibleSelected = null;
            if (!$scope.singleproductShowRerate)
                $scope.singleproductShowRerate = showRerate;
            //anytime a product feature changes, we signal something changed
            $scope.signalProductChoiceChanged();
        }
        else {
            $scope.singleProductInfo.selectedOptionVal.push(optionId);
            // KRE - Looking if the Surcharge selected has to set a DefaultDeductible
            if (defaultDeductibleValue) {
                $scope.singleProductInfo.defaultDeductibleSelected = defaultDeductibleValue.FieldValue;
                $scope.singleProductInfo.selectedDeductibleVal = "0.00";
            }
            $scope.changeDeductible(true, true);
            //
        };


    }
    //for those products that require more information to rate (financial information usually)
    $scope.checkProductComplete = function(){
        var prodData = vehicleProductCoordService.getProductData($scope.singleProductInfo.productInternalId);

        $scope.singleProductInfo.productIncomplete = prodData.productFlags.isIncomplete;
        if (prodData.productFlags.isIncomplete){
            $scope.singleProductInfo.productIncompleteFields = prodData.incompleteFields;
        }
        prodData = null;
    }

    $scope.checkDealInfoComplete = function() {
        return rateQuoteCoordService.DealData.dealInfoComplete();
    }

    //toggle if option is chosen or not
    $scope.toggleUpgradeOption = function(optionId, showRerate){
        rateQuoteRetrievalCoordService.endQuoteRetrieval();
        var idx = $scope.singleProductInfo.selectedUpgradeOptionVal.indexOf(optionId);
        if (idx > -1){
            $scope.singleProductInfo.selectedUpgradeOptionVal.splice(idx,1);
            $scope.singleProductInfo.selectedUpgradeOptionValDisplay.splice(idx,1);
        }
        else {
            $scope.singleProductInfo.selectedUpgradeOptionVal.push(optionId);
            $scope.singleProductInfo.selectedUpgradeOptionValDisplay.push(optionId);
        }
        if (!$scope.singleproductShowRerate)
            $scope.singleproductShowRerate = showRerate;
        $scope.signalProductChoiceChanged();
    }
    //retrieve coverages for the product and set up behavior
    $scope.getCoverages = function(){
        //uses the ".getProductOptionValues" common function that controls the
        // behavior of the product feature (coverage, deductible, etc.)
        $scope.getProductOptionsValues(
            function coverageSetCollection(vals) { $scope.singleProductInfo.availCoverages = vals;}, //options set
            function coverageSetCurrentValue(val) { $scope.singleProductInfo.selectedCoverageVal = val; }, //selected set
            $scope.singleProductInfo.selectedCoverageForce, //switch proposal value
            function coverageRetrieval() { return vehicleProductCoordService.getAvailableCoverages($scope.singleProductInfo.productInternalId); }, //get options
            function existQuoteCoverageValue(quote) {
                var hasBaseProduct = quote.BaseNoUpgradeProductRates != null  && quote.BaseNoUpgradeProductRates.length == 1 && quote.BaseNoUpgradeProductRates[0].BaseRatedProduct != null;
                var hasBaseCoverage = hasBaseProduct && quote.BaseNoUpgradeProductRates[0].BaseRatedCoverage != null;
                if (hasBaseCoverage){
                    return quote.BaseNoUpgradeProductRates[0].BaseRatedCoverage.InternalCoverageId;
                }else{
                    return quote.RatedCoverage.InternalCoverageId;
                }
            },//retrieved from existing
            function coverageChanged() { $scope.changeCoverage(); },//changed option
            function coverageDefaultSelection() {
                var foundcov = null;
                if ($scope.displaySettings && $scope.displaySettings.defaultCoverage){
                    $scope.singleProductInfo.availCoverages.forEach(function(nxtcov){
                        if (nxtcov.ProductCoverage.InternalCoverageId == $scope.displaySettings.defaultCoverage)
                            foundcov = nxtcov.ProductCoverage.InternalCoverageId;
                    });
                }
                if (vehicleProductCoordService.getProductFlags($scope.singleProductInfo.productInternalId).hasUpgrades) {
                    return $scope.singleProductInfo.availCoverages[0].ProductCoverage.InternalCoverageId; //default value
                }
                else if (foundcov){
                    return foundcov;
                }else{
                    return $scope.singleProductInfo.availCoverages[0].ProductCoverage.InternalCoverageId;
                }
            },
            function coverageClearedValues() { $scope.singleProductInfo.selectedDeductibleVal = null; return;}//force clearing other things
        );
    }
    //retrieve deductibles and set up behavior (once coverage chosen)
    $scope.getDeductibles = function() {
        $scope.getProductOptionsValues(
            function deductibleSetCollection(vals) { $scope.singleProductInfo.availDeductibles = vals;}, //options set
            function deductibleSetCurrentValue(val) { $scope.singleProductInfo.selectedDeductibleVal = val; }, //selected set
            $scope.singleProductInfo.selectedDeductibleForce, //switch proposal value
            function deductibleRetrieval() { return vehicleProductCoordService.getAvailableDeductibles($scope.singleProductInfo.productInternalId); }, //get options
            function existQuoteDeductibleValue(quote) {
                var hasBaseProduct = quote.BaseNoUpgradeProductRates != null  && quote.BaseNoUpgradeProductRates.length == 1 && quote.BaseNoUpgradeProductRates[0].BaseRatedProduct != null;
                var hasBaseDeductible = hasBaseProduct && quote.BaseNoUpgradeProductRates[0].BaseRatedDeductible;

                if (hasBaseDeductible){
                    return quote.BaseNoUpgradeProductRates[0].BaseRatedDeductible.InternalDeductibleId;
                }else{
                    return quote.RatedDeductible ? quote.RatedDeductible.InternalDeductibleId : "-1";
                }
            },//retrieved from existing
            function deductibleChanged() { $scope.changeDeductible(); },//changed option
            function deductibleDefaultSelection() {
                var foundded = null;
                if ($scope.displaySettings && $scope.displaySettings.defaultDeductible){
                    $scope.singleProductInfo.availDeductibles.forEach(function(nxtded){
                        if (nxtded.ProductDeductible.InternalDeductibleId == $scope.displaySettings.defaultDeductible)
                            foundded = nxtded.ProductDeductible.InternalDeductibleId;
                    });
                }

                if (vehicleProductCoordService.getProductFlags($scope.singleProductInfo.productInternalId).hasUpgrades) {
                    return $scope.singleProductInfo.availDeductibles[0].ProductDeductible.InternalDeductibleId; //default value
                }
                else if (foundded){
                    return foundded;
                }else{
                    return $scope.singleProductInfo.availDeductibles[0].ProductDeductible.InternalDeductibleId;
                }
            },
            function deductibleClearedValues() { $scope.singleProductInfo.selectedNoUpgradeTermVal = null; return;}//force clearing other things
        );
    }
    //retrieve product options and set up behavior (surcharges)
    $scope.getProductOptionsSurcharges = function() {
        $scope.getProductOptionsValues(
            function surchargeSetCollection(vals) { $scope.singleProductInfo.availOptions = vals;}, //options set
            function surchargeSetCurrentValue(val) { $scope.singleProductInfo.selectedOptionVal = val;
                var ids = {};
                _.each(val, function (eachVal) { ids[eachVal] = true; });
                var out = _.filter($scope.singleProductInfo.availOptions, function (value) {
                    return ids[value.InternalOptionId];
                }, val);
                $scope.singleProductInfo.selectedOptionValDisplay = out;
            },
            $scope.singleProductInfo.selectedOptionForce, //switch proposal value
            function surchargeRetrieval() {
                return vehicleProductCoordService.getAvailableProductOptions($scope.singleProductInfo.productInternalId);
            }, //get options
            function existQuoteSurchargeValues(quote) {
                var vals = [];
                var hasBaseProduct = quote.BaseNoUpgradeProductRates != null  && quote.BaseNoUpgradeProductRates.length == 1 && quote.BaseNoUpgradeProductRates[0].BaseRatedProduct != null;
                var hasBaseOptions = hasBaseProduct && quote.BaseNoUpgradeProductRates[0].BaseRatedProduct.ProductOptions && quote.BaseNoUpgradeProductRates[0].BaseRatedProduct.ProductOptions.length > 0;

                if (hasBaseOptions)
                {
                    quote.BaseNoUpgradeProductRates[0].BaseRatedProduct.ProductOptions.forEach(function(opt){
                        if (opt.UserChoseSurcharge)
                            vals.push(opt.InternalOptionId);
                    });
                }
                else if (quote.RatedProduct.ProductOptions)
                {
                    quote.RatedProduct.ProductOptions.forEach(function(opt){
                        if (opt.UserChoseSurcharge)
                            vals.push(opt.InternalOptionId);
                    });
                }
                return vals;
            },//retrieved from existing
            function surchargeChanged() {
                $scope.changeOptionSurcharge();
            },//changed option
            function surchargeDefaultSelection() {
                if ($scope.defaultSurcharges && $scope.defaultSurcharges.length > 0) {
                    return $scope.defaultSurcharges.map(function (surch) {
                        return surch.ApplicationCode;
                    });
                }
                else
                    return [];
            }, //default value function
            null //no clear function
        );
    }
    //change a surcharge
    $scope.changeOptionSurcharge = function(){
        $scope.signalProductChoiceChanged();
    }
    //change the chosen coverage
    $scope.changeCoverage = function(endRetrieval, showRerate) {
        if (endRetrieval)
            rateQuoteRetrievalCoordService.endQuoteRetrieval();
        //changing main coverage clears everything else
        $scope.singleProductInfo.selectedDeductibleVal = null;//invalidate rating
        $scope.singleProductInfo.selectedNoUpgradeTermVal = null;
        $scope.singleProductInfo.selectedUpgradeCoverageVal = null;
        $scope.singleProductInfo.selectedUpgradeDeductibleVal = null;
        $scope.singleProductInfo.selectedOptionVal = [];
        $scope.singleProductInfo.selectedOptionValDisplay = [];
        $scope.singleProductInfo.selectedUpgradeOptionValDisplay = [];
        $scope.singleProductInfo.selectedOptionForce = [];
        $scope.singleproductShowRerate = showRerate;

        //force refresh of deductibles and options
        if ($scope.singleProductInfo.selectedCoverageVal && $scope.singleProductInfo.selectedCoverageVal.length > 0) {
            vehicleProductCoordService.selectCoverage(
                $scope.singleProductInfo.productInternalId, $scope.singleProductInfo.selectedCoverageVal);

            //if we have surcharges, wait until surcharges are filled before we attempt to rate
            if (!(vehicleProductCoordService.getProductFlags($scope.singleProductInfo.productInternalId).hasSurcharges == 'yes')){
                $scope.signalProductChoiceChanged();
            }

            if (vehicleProductCoordService.getProductFlags($scope.singleProductInfo.productInternalId).hasUpgrades){
                $scope.getDeductibles(endRetrieval);
                $scope.getProductOptionsSurcharges();
                $scope.getBaseNoUpgradeTerms();//need to get any "upgrades" before anything else
            }else{
                //getting surcharges before deductibles so auto-selecting deductible doesn't force rating multiple times
                $scope.getProductOptionsSurcharges();
                $scope.getDeductibles(endRetrieval);
            }
            $scope.singleProductInfo.defaultDeductibleSelected = null;
        }
    }
    //change the deductible
    $scope.changeDeductible = function(endRetrieval, showRerate){
        if (endRetrieval)
            rateQuoteRetrievalCoordService.endQuoteRetrieval();
        if (!$scope.singleproductShowRerate)
            $scope.singleproductShowRerate = showRerate;
        $scope.signalProductChoiceChanged();
    }
    //send an event that product choices have changed for a product
    $scope.signalProductChoiceChanged = function(){
        $scope.singleProductInfo.productRateReady = false;
        $scope.$emit(quoteCreationEvents.productChoiceChanged, $scope.getCurrentProductChoices($scope.singleProductInfo.productInternalId));
        var productChoicesDone = true;
        // chosen a coverage?
        var prodFlags = vehicleProductCoordService.getProductFlags($scope.singleProductInfo.productInternalId);

        productChoicesDone = ($scope.singleProductInfo.selectedCoverageVal!=null || !prodFlags.hasCoverages)
            && ($scope.singleProductInfo.selectedDeductibleVal!=null || !prodFlags.hasDeductibles)
            && ($scope.singleProductInfo.selectedNoUpgradeTermVal!=null || !prodFlags.hasUpgrades)
            && ($scope.singleProductInfo.selectedUpgradeProductVal!=null || !prodFlags.hasUpgrades)
            && ($scope.singleProductInfo.selectedUpgradeCoverageVal!=null || !prodFlags.hasUpgrades)
            && ($scope.singleProductInfo.selectedUpgradeDeductibleVal!=null || !prodFlags.hasUpgradeDeductibles);
        //check to see if the product has surcharges or not, if it does, wait until
        // we've retrieved the "default" surcharges if any
        productChoicesDone &=
            (prodFlags.hasSurcharges == 'no') || (prodFlags.hasSurcharges == 'yes' && $scope.singleProductInfo.surchargeDefaultsRetrieved);

        //are we all good??
        if (productChoicesDone) {
            $scope.singleProductInfo.productRateReady = true;
            if (!$scope.singleproductShowRerate)
                $scope.signalProductChoiceComplete($scope.singleProductInfo.productInternalId);
        }
    }
    //send an event that we are ready to rate the product
    $scope.signalProductChoiceComplete = function() {
        var productData = $scope.getCurrentProductChoices($scope.singleProductInfo.productInternalId);
        var mode = erateSessionVarsService.getQuotingMode();
        var ignoreCachedRates = false;

        if (rateQuoteRetrievalCoordService.inQuoteRetrieval() && mode == quoteIntegrationConstants.menuQuoteIntegrated) {
            // ok if we are retrieving quotes from a previous menu-integrated deal,
            // and the product type is dependent on deal information (GAP), let's ignore
            // any "cached rate" and just rate as-is with the current deal data.
            var productTypeToReRate = null;

            dealProductService.getProductsReRateOnDealChange()
                .then(
                    function gotDealDependentProds(prods) {
                        _.forEach(prods, function (prodtype) {
                            if (prodtype.ApplicationCode.toUpperCase() === $scope.singleProductInfo.productTypeInternalId.toUpperCase()) {
                                ignoreCachedRates = true;
                                if (!dealProductService.getInCleanQueueProcess()) {
                                    growl.success(prodtype.ApplicationCode + ' is being re-rated with new Financial Data.');
                                }
                                else {
                                    dealProductService.setInCleanQueueProcess(false);
                                }
                            }
                        });
                        vehicleRateService.beginRateForProductData(productData, ignoreCachedRates);
                    }
                );
        }else{
            vehicleRateService.beginRateForProductData(productData, ignoreCachedRates);
        }
    };

    //the current product attributes chosen
    $scope.getCurrentProductChoices = function(){
        var prodinfo = angular.copy($scope.singleProductInfo);
        //clear out arrays
        prodinfo.availCoverages = prodinfo.availDeductibles = prodinfo.availOptions = prodinfo.upgradeProducts =
            prodinfo.upgradeCoverages = prodinfo.upgradeDeductibles = prodinfo.upgradeOptions = null;
        //we need to get the product options chosen
        return prodinfo;
    }
    //switching base term for upgrades
    $scope.changeBaseTerm = function(endRetrieval, showRerate){
        if (endRetrieval)
            rateQuoteRetrievalCoordService.endQuoteRetrieval();

        $scope.singleProductInfo.selectedUpgradeCoverageVal = null;
        $scope.singleProductInfo.selectedUpgradeDeductibleVal = null;
        if (!$scope.singleproductShowRerate)
            $scope.singleproductShowRerate = showRerate;
        $scope.signalProductChoiceChanged();

        if ($scope.singleProductInfo.selectedNoUpgradeTermVal && $scope.singleProductInfo.selectedNoUpgradeTermVal.length > 0){
            $scope.signalProductChoiceChanged();

            vehicleProductCoordService.selectBaseNoUpgradeTerm($scope.singleProductInfo.productInternalId, $scope.singleProductInfo.selectedNoUpgradeTermVal);

            $scope.singleProductInfo.selectedUpgradeProductVal = vehicleProductCoordService.getUpgradeProductId($scope.singleProductInfo.productInternalId);
            $scope.getUpgradeCoverages();
        }
    }
    //changing coverage on the "upgrade" selection
    $scope.changeUpgradeCoverage = function(endRetrieval, showRerate){
        if (endRetrieval)
            rateQuoteRetrievalCoordService.endQuoteRetrieval();

        $scope.singleProductInfo.selectedUpgradeDeductibleVal = null;
        if (!$scope.singleproductShowRerate)
            $scope.singleproductShowRerate = showRerate;
        if ($scope.singleProductInfo.selectedUpgradeCoverageVal && $scope.singleProductInfo.selectedUpgradeCoverageVal.length > 0) {
            vehicleProductCoordService.selectUpgradeCoverage(
                $scope.singleProductInfo.productInternalId, $scope.singleProductInfo.selectedUpgradeProductVal,$scope.singleProductInfo.selectedUpgradeCoverageVal )
            //getting surcharges first so auto-selecting deductible doesn't force rating multiple times
            //for no-upgrades, we won't have upgrade deductibles.. so force product change signal again
            //if (vehicleProductCoordService.getProductFlags($scope.singleProductInfo.productInternalId).hasUpgradeDeductibles){
            $scope.getUpgradeProductOptionsSurcharges();
            $scope.getUpgradeDeductibles();
            //}
            $scope.signalProductChoiceChanged();
        }else {
            $scope.signalProductChoiceChanged();
        }
    }
    //changing the "upgrade deductible"
    $scope.changeUpgradeDeductible = function(endRetrieval, showRerate){
        if (endRetrieval)
            rateQuoteRetrievalCoordService.endQuoteRetrieval();
        if (!$scope.singleproductShowRerate)
            $scope.singleproductShowRerate = showRerate;
        $scope.signalProductChoiceChanged();
    }
    //change the 'no upgrade' lw term
    $scope.getBaseNoUpgradeTerms = function(){
        $scope.getProductOptionsValues(
            function baseTermSetCollection(vals) { $scope.singleProductInfo.baseNoUpgradeTerms = vals;}, //options set
            function baseTermSetCurrentValue(val)
            {
                $scope.singleProductInfo.selectedNoUpgradeTermVal = val;
            }, //selected set
            $scope.singleProductInfo.selectedNoUpgradeTermForce, //switch proposal value
            function baseTermRetrieval() { return vehicleProductCoordService.getAvailableBaseTerms($scope.singleProductInfo.productInternalId); }, //get options
            function existQuoteBaseTermValue(quote) {
                var hasBaseProduct = quote.BaseNoUpgradeProductRates != null  && quote.BaseNoUpgradeProductRates.length == 1 && quote.BaseNoUpgradeProductRates[0].BaseRatedProduct != null;
                var hasBaseTerm = hasBaseProduct && quote.BaseNoUpgradeProductRates[0].BaseRatedTerm != null;
                var prodFlags = vehicleProductCoordService.getProductFlags($scope.singleProductInfo.productInternalId);
                if (hasBaseTerm) {
                    return quote.BaseNoUpgradeProductRates[0].BaseRatedTerm.RatedTerm.InternalTermId;
                }else if (prodFlags.hasUpgrades){
                    return quote.RatedTerms[0].RatedTerm.InternalTermId;
                }
            },//retrieved from existing
            function baseTermChanged() { $scope.changeBaseTerm(); },//changed base term
            function baseTermDefaultSelection() { return $scope.singleProductInfo.baseNoUpgradeTerms[0].ProductTerm.InternalTermId;}, //default value
            function baseTermClearedValues() { $scope.singleProductInfo.selectedUpgradeCoverageVal = null; return;}//force clearing other things
        );
    }
    //set upgrade coverage
    $scope.getUpgradeCoverages = function(){
        $scope.getProductOptionsValues(
            function upgradeCoveragesSetCollection(vals) {
                $scope.singleProductInfo.upgradeCoverages = vals;
            }, //options set
            function upgradeCoverageSetCurrentValue(val) {
                $scope.singleProductInfo.selectedUpgradeCoverageVal = val;
            }, //selected set
            $scope.singleProductInfo.selectedUpgradeCoverageForce, //switch proposal value
            function upgradeCoverageRetrieval() { return vehicleProductCoordService.getAvailableUpgradeCoverages($scope.singleProductInfo.productInternalId,$scope.singleProductInfo.selectedUpgradeProductVal); }, //get options
            function existQuoteUpgradeCoverageValue(quote) {
                var hasBaseProduct = quote.BaseNoUpgradeProductRates != null  && quote.BaseNoUpgradeProductRates.length == 1 && quote.BaseNoUpgradeProductRates[0].BaseRatedProduct != null;
                var hasBaseCoverage = hasBaseProduct && quote.BaseNoUpgradeProductRates[0].BaseRatedCoverage != null;
                var prodFlags = vehicleProductCoordService.getProductFlags($scope.singleProductInfo.productInternalId);
                if (hasBaseCoverage) {
                    return quote.RatedCoverage.InternalCoverageId;
                }else if (prodFlags.hasUpgrades){
                    var noUpCovg = _.find($scope.singleProductInfo.upgradeCoverages, function (nxtcov       ) { return nxtcov.ProductCoverage.InternalCoverageId.indexOf('NOUPGRADE') >= 0;});
                    if (noUpCovg!=null)
                        return noUpCovg.ProductCoverage.InternalCoverageId;
                }
            },//retrieved from existing
            function upgradeCoverageChanged() { $scope.changeUpgradeCoverage(); },//changed option
            function upgradeCoverageDefaultSelection() {
                var foundcov = null;
                if ($scope.displaySettings && $scope.displaySettings.defaultCoverage){
                    $scope.singleProductInfo.upgradeCoverages.forEach(function(nxtcov){
                        if (nxtcov.ProductCoverage.InternalCoverageId == $scope.displaySettings.defaultCoverage)
                            foundcov = nxtcov.ProductCoverage.InternalCoverageId;
                    });
                }
                if (foundcov){
                    return foundcov;
                }else{
                    return $scope.singleProductInfo.upgradeCoverages[0].ProductCoverage.InternalCoverageId;
                }
            },
            function upgradeCoverageClearedValues() { $scope.singleProductInfo.selectedUpgradeDeductibleVal = null; return;}//force clearing other things
        );
    }
    //set the upgrade deductibles
    $scope.getUpgradeDeductibles = function(){
        $scope.getProductOptionsValues(
            function upgradeDeductiblesSetCollection(vals) { $scope.singleProductInfo.upgradeDeductibles = vals;}, //options set
            function upgradeDeductibleSetCurrentValue(val) { $scope.singleProductInfo.selectedUpgradeDeductibleVal = val; }, //selected set
            $scope.singleProductInfo.selectedUpgradeDeductibleForce, //switch proposal value
            function upgradeDeductibleRetrieval() { return vehicleProductCoordService.getUpgradeDeductibles($scope.singleProductInfo.productInternalId,$scope.singleProductInfo.selectedUpgradeProductVal); }, //get options
            function existQuoteUpgradeDeductibleValue(quote) {
                var hasBaseProduct = quote.BaseNoUpgradeProductRates != null  && quote.BaseNoUpgradeProductRates.length == 1 && quote.BaseNoUpgradeProductRates[0].BaseRatedProduct != null;
                var hasBaseDeductible = hasBaseProduct && quote.BaseNoUpgradeProductRates[0].BaseRatedDeductible!=null;
                if (hasBaseDeductible) {
                    return quote.RatedDeductible.InternalDeductibleId;
                }
            },//retrieved from existing
            function upgradeDeductibleChanged() { $scope.changeUpgradeDeductible(); },//changed option
            function upgradeDeductibleDefaultValue() {
                var foundded = null;
                if ($scope.displaySettings && $scope.displaySettings.defaultDeductible){
                    $scope.singleProductInfo.upgradeDeductibles.forEach(function(nxtded){
                        if (nxtded.ProductDeductible.InternalDeductibleId == $scope.displaySettings.defaultDeductible)
                            foundded = nxtded.ProductDeductible.InternalDeductibleId;
                    });
                }

                if (foundded){
                    return foundded;
                }else{
                    return $scope.singleProductInfo.upgradeDeductibles[0].ProductDeductible.InternalDeductibleId;
                }
            },
            null //no clear function
        );
    }
    //get the upgrade surcharges
    $scope.getUpgradeProductOptionsSurcharges = function(){
        $scope.getProductOptionsValues(
            function upgradeSurchargesSetCollection(vals) { $scope.singleProductInfo.upgradeOptions = vals;}, //options set
            function upgradeSurchargesSetCurrentValue(val) { $scope.singleProductInfo.selectedUpgradeOptionVal = val; }, //selected set
            $scope.singleProductInfo.selectedUpgradeOptionForce, //switch proposal value
            function upgradeSurchargeRetrieval() { return  vehicleProductCoordService.getUpgradeProductOptions($scope.singleProductInfo.productInternalId,$scope.singleProductInfo.selectedUpgradeProductVal); }, //get options
            function existQuoteUpgradeSurchargeValue(quote) {
                var vals = [];
                var hasBaseProduct = quote.BaseNoUpgradeProductRates != null  && quote.BaseNoUpgradeProductRates.length == 1 && quote.BaseNoUpgradeProductRates[0].BaseRatedProduct != null;
                if (hasBaseProduct && quote.RatedProduct.ProductOptions) {
                    quote.RatedProduct.ProductOptions.forEach(function(opt){
                        if (opt.UserChoseSurcharge)
                            vals.push(opt.InternalOptionId);
                    });
                }
                return vals;
            },//retrieved from existing
            function upgradeSurchargeChanged() { $scope.changeOptionSurcharge(); },//changed option
            null, //no default value function
            null //no clear function
        );
    }
    //used to fill in product option values (common logic among 'get product options')
    $scope.getProductOptionsValues = function(productOptionGroupSetFunc, optionValVariableSetFunc, proposalSwitchVariable,
                                              optionsRetrievalFunc, optionsExistQuoteGetFunc, optionChangedFunc,
                                              optionDefaultSelectFunc, clearSelectedFunc
    ){
        if (clearSelectedFunc)
            clearSelectedFunc();

        var switchIsArray = false
        if (proposalSwitchVariable){
            switchIsArray = angular.isArray(proposalSwitchVariable);
        }

        optionVals = optionsRetrievalFunc();
        productOptionGroupSetFunc(optionVals);

        if (rateQuoteRetrievalCoordService.inQuoteRetrieval() &&
            rateQuoteCoordService.getRateForScenarioCodeProductId(
                rateQuoteScenariosService.getCurrentScenario(),
                $scope.singleProductInfo.productInternalId)!=null) { //retrieving quote, and found a rate
            var quoteRate = rateQuoteCoordService.getRateForScenarioCodeProductId(
                rateQuoteScenariosService.getCurrentScenario(),
                $scope.singleProductInfo.productInternalId);

            optionValVariableSetFunc(optionsExistQuoteGetFunc(quoteRate));
        }
        else if ((!switchIsArray && proposalSwitchVariable) || (switchIsArray && proposalSwitchVariable.length > 0)){
            optionValVariableSetFunc(proposalSwitchVariable);
        }else if (optionValVariableSetFunc && optionVals && optionVals.length > 0 && optionDefaultSelectFunc) {
            optionValVariableSetFunc(optionDefaultSelectFunc());
        }
        if (optionVals && optionVals.length > 0) {
            if (optionChangedFunc)
                optionChangedFunc();
        }
    }
    //respond to changing the proposal
    $scope.$on(quoteCreationEvents.scenarioChanged, function(event, args) {
        $scope.resynchProductOptionsWithRates();
    });
    $scope.$on(quoteCreationEvents.invalidProductTypeChosenContract, function(event, args){
        if (args.prodId == $scope.singleProductInfo.productInternalId){
            $scope.productTypeChooseOK = false;
        }
    })
    //refreshing the quote queue..
    $scope.$on(quoteCreationEvents.refreshQuoteQueue, function(event, args) {
        $scope.resynchProductOptionsWithRates();
    });
    //Switching proposals and/or selecting an existing item, let's re-synch the chosen values
    $scope.resynchProductOptionsWithRates = function(){
        //at this point we've retrieved everything and set up state, so we should have no need
        // to re-do logic related to initially retrieving the quote
        rateQuoteRetrievalCoordService.endQuoteRetrieval();

        $scope.singleProductInfo.selectedCoverageForce= null;//primary coverage
        $scope.singleProductInfo.selectedDeductibleForce= null;//primary deductible
        $scope.singleProductInfo.selectedOptionForce= [];//primary options
        $scope.singleProductInfo.selectedNoUpgradeTermForce= null;//base lw term (no upgrade)
        $scope.singleProductInfo.selectedUpgradeProductForce= null;//upgrade product
        $scope.singleProductInfo.selectedUpgradeCoverageForce= null;//upgrade coverage
        $scope.singleProductInfo.selectedUpgradeDeductibleForc= null;//upgrade deductible
        $scope.singleProductInfo.selectedUpgradeOptionForce= [];//upgrade options

        var myRate = rateQuoteCoordService.getRateForScenarioCodeProductId(rateQuoteScenariosService.getCurrentScenario(),
            $scope.singleProductInfo.productInternalId);
        if (myRate){
            var hasBaseProduct = myRate.BaseNoUpgradeProductRates && quote.BaseNoUpgradeProductRates.length == 1 && myRate.BaseNoUpgradeProductRates[0].BaseRatedProduct;
            var hasBaseCoverage = hasBaseProduct && myRate.BaseNoUpgradeProductRates[0].BaseRatedCoverage!=null;
            var hasBaseDeductible = hasBaseProduct && myRate.BaseNoUpgradeProductRates[0].BaseRatedDeductible!=null;
            var hasBaseTerm = hasBaseProduct && myRate.BaseNoUpgradeProductRates[0].BaseRatedTerm!=null;
            var hasBaseOptions = hasBaseProduct && myRate.BaseNoUpgradeProductRates[0].BaseRatedProduct.ProductOptions!=null && myRate.BaseNoUpgradeProductRates[0].BaseRatedProduct.ProductOptions.length > 0;

            $scope.singleProductInfo.selectedCoverageForce =
                hasBaseCoverage ? myRate.BaseNoUpgradeProductRates[0].BaseRatedCoverage.InternalCoverageId : myRate.RatedCoverage.InternalCoverageId;
            $scope.singleProductInfo.selectedDeductibleForce =
                hasBaseDeductible ? myRate.BaseNoUpgradeProductRates[0].BaseRatedDeductible.InternalDeductibleId : (myRate.RatedDeductible ? myRate.RatedDeductible.InternalDeductibleId : null);
            $scope.singleProductInfo.selectedNoUpgradeTermForce = hasBaseTerm ? myRate.BaseNoUpgradeProductRates[0].BaseRatedTerm.RatedTerm.InternalTermId : null;
            $scope.singleProductInfo.selectedUpgradeProductForce = hasBaseProduct ? vehicleProductCoordService.getUpgradeProductId($scope.singleProductInfo.productInternalId) : null;
            $scope.singleProductInfo.selectedUpgradeCoverageForce = hasBaseProduct && myRate.RatedCoverage ? myRate.RatedCoverage.InternalCoverageId : null;
            $scope.singleProductInfo.selectedUpgradeDeductibleForce = hasBaseProduct && myRate.RatedDeductible ? myRate.RatedDeductible.InternalDeductibleId : null;

            if (hasBaseOptions && myRate.RatedProduct.ProductOptions) {
                myRate.RatedProduct.ProductOptions.forEach(function(opt){
                    if (opt.UserChoseSurcharge)
                        $scope.singleProductInfo.selectedUpgradeOptionForce.push(opt.InternalOptionId);
                });
            }
            if (hasBaseOptions)
            {
                myRate.BaseNoUpgradeProductRates[0].BaseRatedProduct.ProductOptions.forEach(function(opt){
                    if (opt.UserChoseSurcharge)
                        $scope.singleProductInfo.selectedOptionForce.push(opt.InternalOptionId);
                });
            }
            else if (myRate.RatedProduct.ProductOptions)
            {
                myRate.RatedProduct.ProductOptions.forEach(function(opt){
                    if (opt.UserChoseSurcharge)
                        $scope.singleProductInfo.selectedOptionForce.push(opt.InternalOptionId);
                });
            }

            var ratedCov = hasBaseCoverage ? myRate.BaseNoUpgradeProductRates[0].BaseRatedCoverage : myRate.RatedCoverage;
            var ratedDed = hasBaseDeductible ? myRate.BaseNoUpgradeProductRates[0].BaseRatedDeductible : myRate.RatedDeductible;
            var ratedNoUpTerm = hasBaseTerm ? myRate.BaseNoUpgradeProductRates[0].BaseRatedTerm.RatedTerm : null;
            var ratedUpCoverage = hasBaseProduct ? myRate.RatedCoverage : null;
            var ratedUpDed = hasBaseProduct ? myRate.RatedDeductible : null;

            if (!$scope.rateSynchsWithChosenProductOptions(
                    ratedCov, ratedDed, ratedNoUpTerm, ratedUpCoverage, ratedUpDed
                )) {
                $scope.initSelectedValues();
                $scope.getCoverages();//kicks off re-populating and select 'forced' selections
            }
        }
    }

    //synch up rate with current values
    $scope.rateSynchsWithChosenProductOptions = function(Coverage, Deductible, NoUpgradeTerm, UpgradeCoverage, UpgradeDeductible){
        if ($scope.singleProductInfo.selectedCoverageVal != Coverage.InternalCoverageId)
            return false;
        if ($scope.singleProductInfo.selectedDeductibleVal != Deductible.InternalDeductibleId)
            return false;
        if (!($scope.singleProductInfo.selectedNoUpgradeTermVal == null || ($scope.singleProductInfo.selectedNoUpgradeTermVal && NoUpgradeTerm && NoUpgradeTerm.InternalTermId && $scope.singleProductInfo.selectedNoUpgradeTermVal == NoUpgradeTerm.InternalTermId)))
            return false;
        if (!($scope.singleProductInfo.selectedUpgradeCoverageVal == null || ($scope.singleProductInfo.selectedUpgradeCoverageVal && UpgradeCoverage && $scope.singleProductInfo.selectedUpgradeCoverageVal == UpgradeCoverage.InternalCoverageId)))
            return false;
        if (!($scope.singleProductInfo.selectedUpgradeDeductibleVal == null || ($scope.singleProductInfo.selectedUpgradeDeductibleVal && UpgradeDeductible && $scope.singleProductInfo.selectedUpgradeDeductibleVal == UpgradeDeductible.InternalDeductibleId)))
            return false;
        return true;
    }
    $scope.scrollToProduct = function(index) {
        var product = angular.element('[data-product-index="prod-'+ index +'"]')[0];
        product.scrollIntoView({behavior: "smooth"});
    };

    $scope.$on(quoteCreationEvents.RERATE_PRODUCT, function(event, args){
        var prodId = args.productId;
        var prodDefDed = args.productDed;

        if (prodId == $scope.singleProductInfo.productInternalId){
            $scope.singleProductInfo.selectedOptionVal  = [];
            $scope.singleProductInfo.selectedOptionValDisplay = [];
            $scope.singleProductInfo.selectedOptionVal = args.productSurcharges;
            $scope.singleProductInfo.selectedOptionValDisplay = args.productSurcharges;
            //we've likely updated the profit settings, so we need to re-rate the product with
            // chosen values
            $scope.signalProductChoiceComplete();
            $scope.singleProductInfo.selectedDeductibleVal = (prodDefDed == "" || prodDefDed == undefined ?  $scope.singleProductInfo.selectedDeductibleVal : prodDefDed );
        }
    });

    //COM-808 so if the deal data changes
    // and this product requires re-rating, we rerate the product
    $scope.$on(quoteCreationEvents.dealDataChanged, function(event, args){
        var prodsToRerate = args.prodsToReRate;
        var rerateMe = false;
        _.forEach(prodsToRerate, function(prodtype){
            if (prodtype.ApplicationCode.toUpperCase() === $scope.singleProductInfo.productTypeInternalId.toUpperCase()){
                rerateMe = true;
            }
        });
        if (rerateMe){
            $scope.singleProductInfo.productIncomplete = !$scope.checkDealInfoComplete();
            $scope.signalProductChoiceComplete();
        }
    });

    $scope.toggleRerate = function () {
        $scope.signalProductChoiceComplete($scope.singleProductInfo.productInternalId);
        $scope.singleproductShowRerate = false;
    };

}]);
